{
    "header_tab__STORAGE_LOCATION": "Lager",
    "header_tab__CLERK": "Erfasser",
    "header_tab__SALES_REP": "Vertreter",
    "header_tab__CUSTOMER": "Kunden",
    "header_tab__INDUSTRY": "Branchen",
    "header_tab__PRODUCT_GROUP": "Produktgruppen",
    "header_tab__PRODUCT": "Artikel",
    "header_tab__SUPPLIER": "Lieferanten",
    "header_tab__NORMALISED_CATEGORY": "Warengruppen",
    "filter_dropdown_status__label": "Kennzahl",
    "filter_dropdown_status__billed": "Umsatz",
    "filter_dropdown_status__billed_wo_credit_note": "Umsatz (ohne Gutschriften)",
    "filter_dropdown_status__unbilled": "Noch nicht fakturiert",
    "filter_dropdown_status__order_sum": "Auftragseingang",
    "filter_dropdown_unit__label": "Einheit",
    "filter_dropdown_unit__monetary": "Wert",
    "filter_dropdown_unit__units": "Menge",
    "filter_dropdown__period_label": "Zeiträume",
    "filter_dropdown__period": "{{years}} Zeiträume",
    "radio_option__revenue": "Umsatz",
    "radio_option__margin": "Deckungsbeitrag (Umsatz)",
    "radio_option__order_sum": "Auftragseingang",
    "radio_option__order_sum_margin": "Deckungsbeitrag (Auftragseingang)",
    "table_label__revenue_spark_chart": "Umsatz Letzte 24 Monate",
    "table_label__order_sum_spark_chart": "Auftragseingang Letzte 24 Monate",
    "table_label__unbilled_spark_chart": "Noch nicht fakturiert Letzte 24 Monate",
    "table_label__billed_wo_credit_note_spark_chart": "Umsatz o. Gutschriften Letzte 24 Monate",
    "table_label__units_spark_chart": "Menge Letzte 24 Monate",
    "table_label__order_count_spark_chart": "Aufträge Letzte 24 Monate",
    "table_label__units_current": "Menge",
    "table_label__units_last_period": "Menge Vorjahr",
    "table_label__units_delta_amount": "Abweichung",
    "table_label__units_delta_percentage": "Abweichung %",
    "table_label__revenue_period": "Umsatz {{period}}",
    "table_label__order_sum_period": "Auftragseingang {{period}}",
    "table_label__unbilled_period": "Noch nicht fakturiert {{period}}",
    "table_label__billed_wo_credit_note_period": "Umsatz o. Gutschriften {{period}}",
    "table_label__margin_period": "DB {{period}}",
    "table_label__margin_pct_period": "DB % {{period}}",
    "table_label__period_YTD": "{{period}} Lfd. Jahr",
    "table_label__period_TODAY": "{{period}} Heute",
    "table_label__period_YESTERDAY": "{{period}} Gestern",
    "table_label__period_FULL_YEAR": "{{period}} Volles Jahr",
    "table_label__period_LAST_WEEK": "{{period}} Letzte Woche",
    "table_label__period_LAST_MONTH": "{{period}} Letzter Monat",
    "table_label__period_LAST_QUARTER": "{{period}} 3 Mon.",
    "table_label__period_TTM": "{{period}} 12 Monate",
    "table_label__period_CUSTOM_DATES": "{{from, datetime}}-{{to, datetime}}",
    "table_label__gross_margin_current": "DB",
    "table_label__gross_margin_percentage_current": "DB %",
    "table_label__gross_margin_last_period": "DB Vorjahr",
    "table_label__gross_margin_percentage_last_period": "DB % Vorjahr",
    "table_label__gross_margin_delta_amount": "Abweichung",
    "table_label__gross_margin_delta_percentage": "Abweichung %",
    "table_label__revenue_delta_amount": "Abweichung",
    "table_label__revenue_delta_percentage": "Abweichung %",
    "search_placeholder__STORAGE_LOCATION": "Suche nach Lager",
    "search_placeholder__CLERK": "Suche nach Erfasser",
    "search_placeholder__SALES_REP": "Suche nach Vertretern ",
    "search_placeholder__CUSTOMER": "Suche nach Kunden",
    "search_placeholder__INDUSTRY": "Suche nach Branchen",
    "search_placeholder__PRODUCT": "Suche nach Artikeln ",
    "search_placeholder__PRODUCT_GROUP": "Suche nach Produktgruppen",
    "search_placeholder__SUPPLIER": "Suche nach Lieferanten",
    "search_placeholder__NORMALISED_CATEGORY": "Suche nach Warengruppen",
    "revenue_stats__title": "Summe Umsatz",
    "revenue_stats__title_order_sum": "Summe Auftragseingang",
    "revenue_stats__sub_title_ytd": "Lfd. Jahr · jeweils {{range}}",
    "revenue_stats__sub_title_ttm": "Letzte 12 Mon. · Stichtag {{date}}",
    "total_summary__name": "Summe",
    "total_summary__name_tooltip": "Hinweis: Einige Filter können zu Doppelzählungen des Umsatzes führen.",
    "explorer__export": "Export",
    "explorer__export_confirmation_title": "Tipps zum Umgang mit exportierten Daten",
    "explorer__export_confirmation_content_1": "<strong>Datei öffnen:</strong><br/> Plato lädt deine Daten als Excel-Datei (.xlsx) herunter. Du kannst die Datei direkt in Microsoft Excel, Google Sheets oder anderen Tabellenkalkulationsprogrammen öffnen.",
    "explorer__export_confirmation_content_2": "<strong>Vor dem Export filtern:</strong><br/> Wende vor dem Export die passenden Filter an, z. B. Zeitraum und Filterdimension, damit du nur relevante Daten erhältst.",
    "explorer__export_confirmation_content_3": "<strong>Vertrauliche Daten schützen:</strong><br/> Enthält dein Export sensible Informationen wie Deckungsbeiträge, speichere und teile die Datei nur gesichert. Halte dich stets an die Datenschutzrichtlinien deines Unternehmens.",
    "explorer__export_confirmation_accept": "Exportieren",
    "explorer__export_no_data_title": "Keine Daten zum Exportieren",
    "explorer__export_no_data_description": "Für die aktuellen Filter gibt es keine Daten.",
    "explorer__export_failed_title": "Export fehlgeschlagen",
    "explorer__export_failed_description": "Bitte versuche es erneut. Falls das Problem weiterhin besteht, wende dich an den Support."
}
